import { useState } from "react";

import {
  Anchor,
  Button,
  Center,
  Container,
  Group,
  Paper,
  PasswordInput,
  TextInput,
  Title,
} from "@mantine/core";

import { useRecoilState } from "recoil";
import { userGroupState } from "./atom/userGroupState"; // 240109 vy LEE
import { userLevelState } from "./atom/userLevelState"; // 240109 vy LEE
import { userState } from "./atom/userState";

import { postLogin } from "pages/Login/apis/login";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();

  const [id, setId] = useState("");
  const [password, setPassword] = useState("");

  const [user, setUser] = useRecoilState(userState);

  const [userLevel, setUserLevel] = useRecoilState(userLevelState);   // 240109 vy LEE
  const [, setUserGroup] = useRecoilState(userGroupState);   // 240109 vy LEE

  // useEffect(() => {
  //   setUser();
  // }, [setUser]);

  // 추가: useEffect를 사용하여 상태 업데이트 후에 로그 찍기
  // useEffect(() => {
  //   console.log("userLevel updated:", userLevel);
  //   console.log("userGroup updated:", userGroup);
  // }, [userLevel, userGroup]);
    
  const handleLogin = async (id, password) => {
    const response = await postLogin(id, password);
    if (typeof response === "object") {
      setUser(response);
      // console.log("handleLogin/response > ", response);
      setUserLevel(response.fn_level); // 240109 by LEE
      // console.log("handleLogin/userLevel > ", userLevel);
  
      setUserGroup(response.fn_group_id); // 240109 by LEE
      // console.log("handleLogin/userGroup > ", userGroup);
    } else {
      alert("로그인 정보를 다시 확인해 주세요.");
      return;
    }
  };
  
  // 추가: useEffect를 사용하여 userLevel이 변경될 때마다 실행되도록 처리
  useEffect(() => {
    // console.log("< userLevel >--> ", userLevel);
    // console.log("< userGroup >--> ", userGroup);

    // setUserLevel(userLevel);
    // setUserGroup(userGroup);

    if (userLevel === "0") {
      navigate("/home_map");
    } else if (userLevel === "1" || userLevel === "2") {
      navigate("/home_map", {
        state: {
          linkGroupId: user.fn_group_id,
          linkFieldId: user.field_id,
        },
      });
    } else {
      navigate("/");
    }
  }, [userLevel, user.fn_group_id, user.field_id, navigate]);
  
  const handleKeyDown  = (event) => {
    if (event.key === "Enter") {
      // Enter 키가 눌렸을 때 handleLogin 호출
      handleLogin(id, password);
    }
  };

  return (
    <Container
      size={1000}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div style={{ width: "75%" }}>
        <Title
          align="center"
          sx={(theme) => ({
            fontFamily: `Greycliff CF, ${theme.fontFamily}`,
            fontWeight: 900,
          })}
        >
          SafetyRoad 염수 시스템
        </Title>

        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          <TextInput
            label="ID"
            placeholder="ID"
            required
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
          <PasswordInput
            label="Password"
            placeholder="Password"
            required
            mt="md"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e)}
          />
          <Center>
            <Group position="apart" mt="lg">
              <Anchor
                component="button"
                size="sm"
                onClick={() =>
                  alert(
                    "암호를 잃어버린 경우 Admin@safetyroad.net로 메일을 보내주시면 임시 비밀번호를 보내드립니다. 반드시 아래 기재사항을 적어서 보내주십시오. (기재사항: 회사명,아이디,휴대전화번호) 감사합니다."
                  )
                }
              >
                암호를 기억하지 못함
              </Anchor>
            </Group>
          </Center>
          <Button fullWidth mt="xl" onClick={() => handleLogin(id, password)}>
            로그인
          </Button>
        </Paper>
      </div>
    </Container>
  );
}

export default Login;
